
// 公共方法
import { Toast, Indicator } from 'mint-ui'
import store from "../../../src/store"

// 封装toast
var showToast = function (msg) {
	Toast({
		message: msg,
		duration: 1000
	});
}

var showLoading = function (msg) {
	if (!msg) {
		Indicator.open()
	} else {
		Indicator.open(msg)
	}
}

var hideLoading = function () {
	Indicator.close()
}

var localUserInfo = {
	setItem: function (data) {
		localStorage.setItem('userInfo', JSON.stringify(data))
	},
	getItem: function () {
		return JSON.parse(localStorage.getItem('userInfo'))
	}
}

/**
 * 更新面包屑内容
 * @param {*} n 更新类型 2为全部更新，3为局部更新
 * @param {*} newVal 本地存储的数据
 */
function updataBreadCrumb(n, newVal) {
	// console.log('newVal', n, newVal)
	if (n === 2) {
		// 更新所有
		sessionStorage.setItem('navBarActive', JSON.stringify(newVal))
	} else {
		// 更新3级或3级以上，更新部分
		let navBarActive = JSON.parse(sessionStorage.getItem('navBarActive')).concat(newVal)
		console.log('nav', navBarActive)
		sessionStorage.setItem('navBarActive', JSON.stringify(navBarActive))
	}
	// 当不是导航栏的菜单，清空defaultActive
	if (getBreadCrumb().length <= 1) {
		// console.log('1515', '')
		store.state.defaultActive = ''
	}
}

/**
 * 获取面包屑内容
 */
function getBreadCrumb () {
	return JSON.parse(sessionStorage.getItem('navBarActive'))
 }

/**
 * 本地存储数据 storage
 * sessionStorage  临时存储，在关闭窗口或标签页之后将会删除这些数据
 * localStorage    没有过期时间，直至手动删除
 */
let storage = {
	sessionSetItem: function (key, value) {
		sessionStorage.setItem(key, JSON.stringify(value))
	},
	sessionGetItem: function (key) {
		return JSON.parse(sessionStorage.getItem(key))
	},
	sessionRemoveItem: function (key) {
		sessionStorage.removeItem(key)
	},

	/* 永久存储 */
	localSetItem: function (key, value) {
		localStorage.setItem(key, JSON.stringify(value))
	},
	localGetItem: function (key) {
		return JSON.parse(localStorage.getItem(key))
	},
	localRemoveItem: function (key) {
		localStorage.removeItem(key)
	},
}


//  检查数组是否有重复的数据  数组格式为[{a:1,b:1}]
function isRepeat(arr, checkVal) {
	let hash = {}
	let value = ''
	for (let i in arr) {
		// console.log('arr[i][checkVal]', arr[i][checkVal])
		// console.log('hash[arr[i][checkVal]]', hash[arr[i][checkVal]])
		// console.log('i', i)
		if (hash[arr[i][checkVal]]) {
			// return true
			value = '有'
			// console.log('有', i)
		} else {
			// console.log('无', '')
			hash[arr[i][checkVal]] = true
		}
	}
	let status = value === '有' ? true : false
	return status
}

// 深拷贝对象
function deepCopy(data) {
	return JSON.parse(JSON.stringify(data))
}
//转换时间格式
function formatFun(time, format) {
	var t = new Date(time);
	var tf = function(i) {
		return (i < 10 ? "0" : "") + i;
	};
	return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function(a) {
		switch (a) {
			case "yyyy":
				return tf(t.getFullYear());
				break;
			case "MM":
				return tf(t.getMonth() + 1);
				break;
			case "mm":
				return tf(t.getMinutes());
				break;
			case "dd":
				return tf(t.getDate());
				break;
			case "HH":
				return tf(t.getHours());
				break;
			case "ss":
				return tf(t.getSeconds());
				break;
		}
	});
}



/**
* 复制文本
*/
function copyText(id) {
	console.log('id', id)
	var range = document.createRange()
	range.selectNode(document.getElementById(id))
	var selection = window.getSelection()
	if (selection.rangeCount > 0) selection.removeAllRanges()
	selection.addRange(range)
	// document.execCommand('Copy', false, null)
	return new Promise(function (resolve, reject) {
		if (document.execCommand('Copy', false, null)) {
			resolve()
		} else {
			showToast('当前设备暂不支持复制链接')
			reject()
		}
	})
}

// 判断一位数组的值是否都相等
function isAllEqual(array) {
	if (array.length > 0) {
		return !array.some(function (value, index) {
			return value !== array[0];
		});
	} else {
		return true;
	}
}

export {
	showToast,
	showLoading,
	hideLoading,
	localUserInfo,
	updataBreadCrumb,
	getBreadCrumb,
	storage,
	isRepeat,
	deepCopy,
	formatFun,
	copyText,
	isAllEqual
}


//////////////////
// WEBPACK FOOTER
// ./static/js/utility/utility.js
// module id = Omly
// module chunks = 1